import React from 'react';
import {t} from 'ttag';
import {useField} from 'formik';
import * as Title from '../../../../../../components/title/title.jsx';
import {Input} from '../../../../../../components/form/form.jsx';

const Name = () => {
  const [field, meta, helpers] = useField('description_short');

  const {error, touched} = meta;
  const {setValue} = helpers;

  const isValid = !(error && touched);

  return (
    <>
      <Title.H3 style={{marginBottom: 8}}>{t`Integration name`}</Title.H3>

      <Input
        {...field}
        placeholder={t`Integration name`}
        isValid={isValid}
        style={{marginBottom: 16}}
        onChange={setValue}
      />
    </>
  );
};

export default Name;
